import { render, staticRenderFns } from "./MarkReceivedDrawer.vue?vue&type=template&id=99bc140c&scoped=true&lang=pug&"
import script from "./MarkReceivedDrawer.vue?vue&type=script&lang=js&"
export * from "./MarkReceivedDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MarkReceivedDrawer.vue?vue&type=style&index=0&id=99bc140c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bc140c",
  null
  
)

/* custom blocks */
import block0 from "./MarkReceivedDrawer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports